import React, { Component } from "react";
import PropTypes from "prop-types";
import ButtonIcon from "../button/ButtonIcon";
import TooltipButton from "../tooltip/TooltipButton";
import { v1 as uuidv1 } from "uuid";
class InformationalPopupContent extends Component {
	handleWindowClick = (e) => {
		if (!e || !e.target) return;

		let currentElement = e.target;
		while (currentElement) {
			if (currentElement.classList.contains("info-popup-content")) return;
			currentElement = currentElement.parentElement;
		}
		window.removeEventListener("click", this.handleWindowClick);
	};
	render() {
		return (
			<TooltipButton
				className="info-popup"
				id={uuidv1()}
				content={this.props.data.html}
				position="top"
				tooltipPosition="right"
				clickable={true}
			>
				<ButtonIcon type="info-popup" color="teal" isButton={false} />
			</TooltipButton>
		);
	}
}

InformationalPopupContent.propTypes = {
	data: PropTypes.shape({
		html: PropTypes.string.isRequired
	})
};

export default InformationalPopupContent;
